import { Pipe, PipeTransform } from '@angular/core';
import { DictionaryStorageService } from '../storages/dictionary-storage.service';
import { KeyValue } from '@angular/common';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'dict'
})
export class DictPipe implements PipeTransform {

  constructor(private dictionaryStorageService: DictionaryStorageService) {
  }

  transform(value: any): Observable<Array<KeyValue<string, number>>> {
    if (!value) {
      return of([]);
    }

    return this.dictionaryStorageService.getItems(value);
  }
}
